import { render, staticRenderFns } from "./UsagesChart.vue?vue&type=template&id=b139a942"
import script from "./UsagesChart.vue?vue&type=script&lang=js"
export * from "./UsagesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports